export const getDirectionAttribute = (isDeparture, name) => {
    const attribute = {};
    const direction = isDeparture ? 'departure' : 'arrival';
    attribute[`data-${direction}-${name}`] = true;
    return attribute;
};
